import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyOwned } from 'src/app/models/company/company-models.model';

@HateoasResource('note')
export class Note extends CompanyOwned {
  public afgehandeld!: boolean;
  public bericht!: string;
  public collectie!: NoteCollection;
  public gebruiker!: string;
  public naam!: string;
  public rgsObjectId!: string;
  public gelezen: Read[] = [];
}
export interface Read {
  bedrijf: string;
  gebruiker: string;
  tijdstip: Date;
}

export enum NoteCollection {
  INSPECTION = 'inspection',
  SCENARIO = 'scenario',
}
